import { useMutation } from "@apollo/client";
import discussedTopicSvg from "@static/img/topic-discussed.svg";
import undiscussedTopicSvg from "@static/img/topic-undiscussed.svg";
import { MouseEventHandler } from "react";

import Tooltip from "@components/tooltip/tooltip";
import { topicState } from "@helpers/constants";
import { getAssetUrl } from "@helpers/helpers";
import { showConfetti } from "@helpers/helpers";

import toggleTopicStateMutation from "./graphql/toggle-topic-state-mutation";

const TopicCTA = ({
  topic,
  isStatic = false,
}: {
  topic: any;
  isStatic?: boolean;
}) => {
  const [toggleState] = useMutation(toggleTopicStateMutation);

  const handleClickToggle: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    if (isStatic) return;
    const newState =
      topic.state === topicState.closed ? topicState.open : topicState.closed;
    toggleState({
      variables: {
        topicId: topic.id,
        state: newState,
      },
      optimisticResponse: {
        createOrUpdateTopic: {
          topic: {
            ...topic,
            state: newState,
          },
        },
      },
    });
  };

  const isDiscussed = topic.state === topicState.closed;

  if (isStatic) return null;
  return (
    <Tooltip text="Mark topic as discussed">
      <button
        disabled={isStatic}
        onClick={(e) => {
          if (!isDiscussed) {
            showConfetti({
              confettiNumber: 40,
              confettiRadius: 4,
              confettiColors: ["#10b981", "#34d399", "#6ee7b7", "#a7f3d0"],
            });
          }
          handleClickToggle(e);
        }}
        className="flex items-center justify-center h-6 w-6 shrink-0 rounded hover:bg-gray-100"
        aria-label="Mark topic as discussed"
      >
        <img
          src={getAssetUrl(
            isDiscussed ? discussedTopicSvg : undiscussedTopicSvg,
          )}
          className="h-4 w-4"
        />
      </button>
    </Tooltip>
  );
};

export default TopicCTA;
